import '../../../styles/index.css'
import './MenuUsuario.css';
import CloseMenuLateral from '../../../assets/icons/Close Icon.svg'
import { GoogleLogout } from 'react-google-login'
import { useState, useEffect } from 'react';
import { apiUser } from '../../../api/api';
import $ from 'jquery'
import { Link, useNavigate } from 'react-router-dom'

function MenuUsuario({ nome, email, image, logoutGoogleSuccess, clientId }) {

    const [setups, setSetups] = useState([])
    const navigate = useNavigate()

    useEffect(() => {

        const menuAtual = document.querySelector('.menu-lateral-direito')

        menuAtual.addEventListener('show.bs.collapse', (event) => {
            $('<div class="overlay"></div>').appendTo(document.body);
            $('body').css('overflow', 'hidden')
        })

    }, [])

    useEffect(() => {

        if (email) {

            apiUser.pegaSetups(email).then((response) => {

                console.log(response)
                setSetups(response)

            }).catch((error) => {

                console.log(error)

            })

        }

    }, [email])

    const removeOverlay = () => {
        $('.overlay').remove()
        $('body').css('overflow', 'auto')
    }

    return (

        <div className='menu-lateral-direito collapse collapse-horizontal' id="menuLateralDireito">

            <button className='botaoFecharmenu-lateral-direito' data-bs-toggle="collapse" data-bs-target="#menuLateralDireito" aria-expanded="false" onClick={removeOverlay}>
                <img src={CloseMenuLateral} alt="Fechar Menu Lateral" />
            </button>

            <div className='usuarioFotoNome'>

                <img className='fotoUsuario' src={image} alt="Foto do Usuário" />

                <div className='olaUsuario'>

                    <h5>Olá,</h5>
                    <h4>{nome}</h4>

                </div>

            </div>

            <ul className='menu-lateral-direito_lista mt-3'>

                {
                    setups.length > 0 ? <li>

                        <div className="dropdown">
                            <p className="bt1 menu-lateral-direito_link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Meus Setups
                            </p>
                            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-dark">

                                {
                                    setups.map((setup, index) => {
                                        return (
                                            <li key={index}>
                                                <Link to={setup.url} className='dropdown-item link' onClick={() => $('.botaoFecharmenu-lateral-direito').click()}>{setup.name}</Link>
                                            </li>
                                        )
                                    })
                                }

                                {/* <li><a className="dropdown-item" href="#">Action</a></li>
                            <li><a className="dropdown-item" href="#">Another action</a></li>
                            <li><a className="dropdown-item" href="#">Something else here</a></li> */}

                            </ul>

                        </div>

                    </li>

                        : null

                }

                <li>
                    <GoogleLogout
                        clientId={clientId}
                        render={renderProps => (
                            <div onClick={renderProps.onClick} disabled={renderProps.disabled}>
                                <p className='bt1 menu-lateral-direito_link' onClick={() => {
                                    $('.botaoFecharmenu-lateral-direito').click()
                                    navigate('/')
                                    }}>Logout</p>
                            </div>
                        )}
                        onLogoutSuccess={logoutGoogleSuccess}
                    />
                </li>

            </ul>

        </div>

    );
}

export default MenuUsuario;
